import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { CookiesProvider } from 'react-cookie'
import { ToastContainer } from 'react-toastify'
import UserProvider from './Context/UserLocation'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import 'swiper/swiper-bundle.css'

import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css'
import 'react-toastify/dist/ReactToastify.css'

import 'react-lazy-load-image-component/src/effects/blur.css'
import 'react-lazy-load-image-component/src/effects/opacity.css'

import 'react-loading-skeleton/dist/skeleton.css'

import 'react-phone-input-2/lib/style.css'

import 'react-quill/dist/quill.snow.css'

import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <CookiesProvider defaultSetOptions={{
 path: '/', expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) // Cookie will expire in 7 days
 }}>
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </UserProvider>
      <ToastContainer position='bottom-left' />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </CookiesProvider>
)

reportWebVitals()
